"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DmsFormSubmitButton = void 0;
var _react = _interopRequireDefault(require("react"));
var _dmsbasereact = require("dmsbasereact");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const DmsFormSubmitButton = _ref => {
  let {
    label = _dmsbasereact.intl.get("Save").d("Save"),
    variant = "contained",
    color = "success",
    props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_dmsbasereact.DmsButton, _extends({
    variant: variant,
    color: color,
    type: "submit"
  }, props), label);
};
exports.DmsFormSubmitButton = DmsFormSubmitButton;